import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import BookStatusChangePopup from 'rebook/apps/books/components/BookStatusChangePopup';
import Button from 'rebook/apps/base/components/Button';

import styles from './style.scss';


class BookOpenStatusChangePopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopupOpened: false,
      response: '',
      shelveExist: null,
      makeNewShelve: null,
      isBookOnAnyShelve: null,
    };
  }

  componentDidMount() {
    const { user } = this.props;

    const url = `/api/bookshelf/?user=${user.id}`;
    const params = {
      apiVersion: 3,
      method: 'GET',
    };
    fetchQuery(url, params).then((response) => {
      if (response.resp.json.objects.length > 0) {
        this.setState({ shelveExist: true, response: response });
      }
      this.setState({ makeNewShelve: true, response: response });
    }).catch(() => {
    });
  }

  static getDerivedStateFromProps(props) {
    if (props.bookDetail.userBookshelfList && props.bookDetail.userBookshelfList.length > 0) {
      return { isBookOnAnyShelve: true };
    }
    return { isBookOnAnyShelve: false };
  }


  handleClickOutside() {
    this.setState({ isPopupOpened: false });
  };

  onChangeStatus(status) {
    this.props.onChangeStatus(status);
    this.setState({ isPopupOpened: false });
  }

  onClosePopup() {
    this.setState({ isPopupOpened: false });
  }

  render() {
    const { user, bookId, bookTitle, readingStatus, extraClassName, bookType, book } = this.props;
    const {
      isPopupOpened,
      response,
      shelveExist,
      makeNewShelve,
      isBookOnAnyShelve,
    } = this.state;
    return (
      <div> {/* div нужен, чтобы корректно работал onClickOutside */}
        {isPopupOpened && (
          <BookStatusChangePopup
            ref={(popup) => {
              this.popup = popup;
            }}
            bottom={'70px'}
            left={'-224px'}
            bookId={bookId}
            bookType={bookType}
            onChangeStatus={(status) => this.onChangeStatus(status)}
            onClosePopup={() => this.onClosePopup()}
            bookTitle={bookTitle}
            readingStatus={readingStatus}
            book={book}
            user={user}
            response={response}
            shelveExist={shelveExist}
            makeNewShelve={makeNewShelve}
            isBookOnAnyShelve={isBookOnAnyShelve} />
        )}
        <Button
          extraClassName={extraClassName}
          handleClick={() => {
            this.setState((prevState) => {
              return { isPopupOpened: !prevState.isPopupOpened };
            });
          }}>
          <span className={styles.dots} />
        </Button>
      </div>
    );
  }
}

BookOpenStatusChangePopup.propTypes = {
  bookType: PropTypes.string,
  readingStatus: PropTypes.number,
  bookTitle: PropTypes.string,
  bookId: PropTypes.number,
};

BookOpenStatusChangePopup.defaultProps = {
  bookType: 'text',
  readingStatus: 0,
  bookTitle: '',
  bookId: 0,
};

export default onClickOutside(BookOpenStatusChangePopup);
